import React from 'react';
import { useNavigate } from 'react-router-dom';
import './legal.css';

// NEW: SEO
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div
      className="privacy-policy"
      style={{ padding: "2rem", maxWidth: "800px", margin: "auto" }}
    >
      {/* SEO: meta for Privacy Policy page */}
      <SEO
        title="Privacy Policy - Talkvee"
        description="Read the Privacy Policy for Talkvee. Learn how we handle user login, session data, and safety while ensuring your video chats remain private."
        pathname="/privacy"
        robots="index, follow"
      />

      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>

      <h1>Privacy Policy for Talkvee</h1>
      <p><strong>Last Updated:</strong> 01/05/2025</p>

      <h2>Introduction</h2>
      <p>
        Talkvee (“we”, “us”, or “our”) is a random video chat app designed with user privacy in mind.
        This Privacy Policy explains what data we collect, how we use it, and how we protect it.
        By using Talkvee, you agree to the terms described here.
      </p>

      <h2>User Login & Identity</h2>
      <p>
        Talkvee requires all users to log in before using the app. You may choose from:
      </p>
      <ul>
        <li><strong>Google or Facebook:</strong> We collect your name, email, and a unique user ID provided by the platform.</li>
        <li><strong>Guest Login:</strong> We generate an anonymous internal ID. No personal information is collected or linked to this ID.</li>
      </ul>
      <p>
        This login system allows us to ensure safety and enable moderation, such as banning users who violate our rules. No login information is ever shared or sold.
      </p>

      <h2>What Information We Collect</h2>
      <ul>
        <li>Authentication data (e.g., user ID, name, email for Google/Facebook users)</li>
        <li>Anonymous session ID for guest users</li>
        <li>Technical session data (such as IP address or connection status for moderation and abuse prevention)</li>
      </ul>

      <h2>Media Access</h2>
      <p>
        To support video chat, Talkvee accesses your device’s camera and microphone. These streams are never recorded, stored, or transmitted to third parties. They are used only during active conversations and only between matched users.
      </p>

      <h2>Cookies & Local Storage</h2>
      <p>
        Talkvee uses local storage to manage session data and improve the chat experience. We do not use cookies for advertising or third-party tracking.
      </p>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To connect you with others via video chat</li>
        <li>To ensure the service works reliably and securely</li>
        <li>To identify and restrict abusive users (e.g., through bans)</li>
      </ul>

      <h2>Data Sharing</h2>
      <p>
        We do not sell, rent, or share your personal data with advertisers, analytics platforms, or any third parties. All data remains private and is used only to operate and protect the Talkvee platform.
      </p>

      <h2>Data Security & Retention</h2>
      <p>
        We use secure storage and transmission methods to protect your data. Personal data is retained only as long as necessary for account and moderation purposes. Media streams and session activity are not saved after a chat ends.
      </p>

      <h2>Your Rights</h2>
      <p>
        You may request deletion of your data at any time by emailing us at <a href="mailto:contact@talkvee.com">contact@talkvee.com</a>. Please include your login method (Google, Facebook, or Guest) and any relevant ID if possible.
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        We may update this policy to reflect changes in our service or legal obligations. Updates will be posted here with the latest revision date.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please reach out to us at <a href="mailto:contact@talkvee.com">contact@talkvee.com</a>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
